import { NgClass, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterLink, RouterOutlet } from '@angular/router';
import { FuseFullscreenComponent } from '@fuse/components/fullscreen';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { FuseHorizontalNavigationComponent, FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { Navigation } from 'app/core/navigation/navigation.types';
import { QuickChatComponent } from 'app/layout/common/quick-chat/quick-chat.component';
import { ShortcutsComponent } from 'app/layout/common/shortcuts/shortcuts.component';
import { Subject, takeUntil } from 'rxjs';
import { NetworkPanelComponent } from 'app/modules/network_panel/network_panel.component';
import { AuthService } from 'app/core/auth/auth.service';
// import { AuthService } from 'app/core/auth/auth.service';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { WebStorage } from 'app/core/shared-services/web.storage';
import { FooterComponent } from 'app/modules/landing/footer/footer.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { sha256 } from 'js-sha256';
import { defaultNavigation } from 'app/mock-api/common/navigation/data';
import { defaultLoggedInNavigation } from 'app/mock-api/common/navigation/data';
import { MatDividerModule } from "@angular/material/divider";
import { MatTabsModule } from '@angular/material/tabs';
import { WhatsappButtonComponent } from 'app/shared/components/whatsapp-button/whatsapp-button.component';



@Component({
    selector     : 'enterprise-layout',
    templateUrl  : './enterprise.component.html',
    styleUrls    : ['./enterprise.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    imports: [
    MatMenuModule, MatBadgeModule, FooterComponent, SharedMethodsModule, FuseLoadingBarComponent, NgIf, RouterLink,
    FuseVerticalNavigationComponent, MatButtonModule, MatIconModule, FuseFullscreenComponent, ShortcutsComponent,
    FuseHorizontalNavigationComponent, RouterOutlet, QuickChatComponent, NetworkPanelComponent,
    MatDividerModule, MatTabsModule, NgClass, NgTemplateOutlet, WhatsappButtonComponent
],
})
export class EnterpriseLayoutComponent implements OnInit, OnDestroy
{
    @ViewChild('searchTextRef') searchInputRef: ElementRef;
    
    isScreenSmall: boolean;
    navigation: Navigation;
    loggedIn: boolean;
    customerAccount:any;
    shortenedProfileDisplay:string;
    public cartValue: number;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private _authService: AuthService,
        private _sharedMethods: SharedMethodsModule,
        private router: Router,
        private _webStorage: WebStorage,
        private dialog: MatDialog,
    


    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    async ngOnInit()
    {
        
        // this._fuseNavigationService.storeNavigation('guest', defaultNavigation);
        // this._fuseNavigationService.storeNavigation('loggedIn', defaultLoggedInNavigation);


        // Subscribe to navigation data
        this._navigationService.navigation$
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe((navigation: Navigation) =>
            {
                this.navigation = navigation;
            });
            
            // Subscribe to media changes
            this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) =>
                {
                    // Check if the screen is small
                    this.isScreenSmall = !matchingAliases.includes('md');
                });
                
                
                var accessToken = this._authService.accessToken;
            
                
                if (accessToken)
                    {            
                        this.loadCustomerAccount();
                    }
                else {
                    this.loggedIn = false;
                    }
                    
                    // Register to Cart Subject
                    this._webStorage.CartInfo.subscribe({
                        next: (res) => {
                            if (res.PackageEntityID) {
                                this.cartValue = 1
                            } else {
                                this.cartValue = 0
                            }
                        }
                    });

    }

    private async loadCustomerAccount(): Promise<void> 
    {


        const res = await this._sharedMethods.getCustomerAccount();
        
        if (res.success && res.result) 
        {
            this.customerAccount = res.result;
            this.loggedIn = true;
            this.shortenedProfileDisplay = this.getFirstLetters(this.customerAccount.AccountName);
        } 
        else 
        {
            this.loggedIn = false;
        }
    }
    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void
    {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);
        // const x = this._fuseNavigationService.getNavigation()

        if ( navigation )
        {
            // Toggle the opened status
            navigation.toggle();
        }
    }

    getFirstLetters(profileName)
    {
        return profileName
          .split(' ')
          .map(word => word[0])
          .join('');
    }

    menuItemClick(...navItems) 
    {
        const navObj = navItems.filter(Boolean);
        const lastItem = navObj[navObj.length - 1];
        if (lastItem && lastItem.includes('#')) {
            const [route, fragment] = lastItem.split('#');
            navObj[navObj.length - 1] = route;
            this.router.navigate(navObj, { fragment: fragment });
        } else {
            this.router.navigate(navObj);
        }
    }

    signOut(): void
    {
        sessionStorage.removeItem('emailHash');
        sessionStorage.removeItem('phoneHash');

        this._router.navigate(['/sign-out']);
        // this.dialog.closeAll();
    }

    signIn(): void
    {
        sessionStorage.removeItem("accessToken");
        this._router.navigate(['/sign-in']);
    }

    signUpRequired(){
        // ## BUG FIX FOR CART AND LOGIN PAGE ##
        sessionStorage.setItem('signUpRequired', null);
    }


    showCart(){
       const token = this._authService.accessToken;
        if(token){
            return true
        }else{
            return false;
        }
    }

    focusOnSearch(): void 
    {
        this.searchInputRef.nativeElement.focus();
    }

    goToNetworkStatus(): void
    {
        window.open('https://www.Infinifi.co.za/network-status', '_blank');
    }

    goToHelp(): void
    {
        window.open('https://www.Infinifi.co.za/help', '_blank');
    }

    goToSpeedTest() {
        window.open('https://speed.Infinifi.co.za/', '_blank');
        
    }

    goToContactUs() {
        window.open('https://www.Infinifi.co.za/contact-us', '_blank');
    }

    /**
     * Check if a route is currently active
     */
    isActiveRoute(route: string): boolean {
        const currentUrl = this.router.url;
        
        // Exact match
        if (currentUrl === route) {
            return true;
        }
        
        // For dashboard, only match the exact dashboard route, not sub-routes
        if (route === '/dashboard') {
            return currentUrl === '/dashboard';
        }
        
        // For other routes, check if current URL starts with the route
        return currentUrl.startsWith(route + '/');
    }

    /**
     * Check if we should hide the bottom navigation (when not signed in)
     */
    shouldHideBottomNav(): boolean {
        return !this.loggedIn;
    }

    /**
     * Check if current route is the home screen
     */
    isHomeScreen(): boolean {
        return this.router.url === '/home' || this.router.url === '/';
    }

    /**
     * Check if mobile screen and not on home route
     */
    isMobileAndNotHome(): boolean {
        return this.isScreenSmall && !this.isHomeScreen();
    }

}
